import { TFasterPayoutBank } from './types';

type RawFasterPayoutBank = TFasterPayoutBank & {
  Logo?: string;
  MemberId?: string;
  Id?: string | number;
  Name?: string;
};

export function isFpsMemberId(
  value: string | number | undefined | null,
): boolean {
  if (value == null || value === '') return false;
  return /^\d{9,}$/.test(String(value));
}

export function getFasterPayoutBankLogoPath(
  bank: TFasterPayoutBank,
): string | undefined {
  const raw = bank as RawFasterPayoutBank;
  const logoFromApi = bank.logo ?? raw.Logo;
  if (logoFromApi) return logoFromApi;

  const memberId = bank.memberId ?? raw.MemberId;
  if (isFpsMemberId(memberId)) {
    return `/static/fps-bank-logos/${memberId}.png`;
  }

  if (isFpsMemberId(bank.id)) {
    return `/static/fps-bank-logos/${bank.id}.png`;
  }

  return undefined;
}

export function normalizeFasterPayoutBank(
  bank: TFasterPayoutBank,
): TFasterPayoutBank {
  const raw = bank as RawFasterPayoutBank;
  const memberId =
    bank.memberId ?? raw.MemberId ?? String(bank.id ?? raw.Id ?? '');

  return {
    ...bank,
    name: bank.name ?? raw.Name ?? '',
    memberId,
    logo: getFasterPayoutBankLogoPath({
      ...bank,
      memberId,
      logo: bank.logo ?? raw.Logo,
    }),
  };
}
